<app-shared-dialog [title]="'Promotions'" [options]="{ hideConfirm: true }" (cancel)="close()">
  <div class="gifts-container" *ngIf="gifts.length > 0">
    <ng-container *ngFor="let gift of gifts">
      <div class="gift">
        <ui-svg-icon svgIcon="reward" size="medium"></ui-svg-icon>
        <div class="gift-content">
          <span class="gift-name">{{ getGiftMessage(gift).pricebook }}</span>
          <span class="gift-message" [innerHTML]="getGiftMessage(gift).message"></span>
        </div>
      </div>
    </ng-container>
  </div>
</app-shared-dialog>
